import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeEvery } from 'redux-saga/effects';

import { STUDENT_DATA_UPDATE_SAGA } from 'reduxToolkit/actions';
import { commonSlice, studentDataUpdateSlice } from 'reduxToolkit/reducers';
import { studentReducerTypes } from 'types';
import { apiCall, apiRoutes, getApiErrorMessage } from 'utils/helpers';

const { studentDataUpdateFailed, studentDataUpdateSuccess, studentDataUpdateStart } = studentDataUpdateSlice.actions;
const { exceptionHandlerRequest } = commonSlice.actions;

const studentDataUpdateSaga = function* (payloadData: PayloadAction<studentReducerTypes.IStudentDataUpdateForm>): any {
    yield put(studentDataUpdateStart(payloadData.payload));
    try {
        const { id } = payloadData.payload;
        const data = payloadData.payload;
        let url: any = null;

        if (id) {
            url = { ...apiRoutes.updateStudent, data };
            url.apiPath = url.apiPath.replace(
                ':studentId',
                payloadData.payload.id ? payloadData.payload.id.toString() : ''
            );
        } else {
            url = { ...apiRoutes.addStudent, data };
        }
        const response = yield apiCall(url);
        if (response.status === 200) {
            yield put(studentDataUpdateSuccess(response.data));
        } else {
            const errorData = {
                status: false,
                error: getApiErrorMessage(response),
            };
            yield put(studentDataUpdateFailed(errorData));
        }
    } catch (error) {
        yield put(exceptionHandlerRequest(error));
    }
};

export const takeStudentDataUpdateRequest = function* () {
    yield takeEvery(STUDENT_DATA_UPDATE_SAGA, studentDataUpdateSaga);
};
